// Pagination.js
import React from 'react'
import ReactPaginate from 'react-paginate'

const Pagination = ({ currentPage, onPageChange, totalPages }) => {
  return (
    <div className="row mt-3">
      <div className="col-12">
        <ReactPaginate
          onPageChange={onPageChange}
          initialPage={currentPage - 1} // Start from page 1
          forcePage={currentPage - 1}
          pageCount={totalPages}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          previousLabel="Previous"
          nextLabel="Next"
          breakLabel="..."
          containerClassName={'pagination-container'}
          pageClassName={'pagination-page'}
          pageLinkClassName={'pagination-link'}
          previousClassName={'pagination-previous'}
          nextClassName={'pagination-next'}
          activeClassName={'pagination-active'}
          disabledClassName={'pagination-disabled'}
        />
      </div>
    </div>
  )
}

export default Pagination
